export default "__VITE_ASSET__CkZheDm0__"